import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { CreditCard, Check, X, AlertTriangle } from 'lucide-react';
import Layout from '../components/Layout';
import { Card, Button, Toast } from '../components/ds';
import { paymentService } from '../services';

const FONT = "'IBM Plex Sans', ui-sans-serif, system-ui, -apple-system, 'Segoe UI', Roboto, sans-serif";

// Lokale Mock-Bezahlseite (AUD-24) — ersetzt checkout.stripe.com, wenn
// PAYMENT_PROVIDER=mock. Jeder Button löst über /payments/mock/complete ein
// signiertes Webhook-Event aus (oder bricht ab) und leitet weiter.
function MockCheckoutPage() {
  const location = useLocation();
  const sessionId = new URLSearchParams(location.search).get('session');
  const [busy, setBusy] = useState(null); // 'success' | 'failed' | 'cancel'
  const [toast, setToast] = useState(null);

  const run = async (outcome) => {
    if (!sessionId) {
      setToast({ tone: 'critical', message: 'Keine Mock-Session in der URL.' });
      return;
    }
    setBusy(outcome);
    try {
      const { data } = await paymentService.completeMockCheckout(sessionId, outcome);
      window.location.href = data.redirectUrl;
    } catch (err) {
      const msg = err?.response?.data?.error || 'Mock-Checkout fehlgeschlagen.';
      setToast({ tone: 'critical', message: msg });
      setBusy(null);
    }
  };

  return (
    <Layout>
      <div style={{ padding: '64px 40px', maxWidth: 460, margin: '0 auto', fontFamily: FONT }}>
        <Card padding={32}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 8 }}>
            <CreditCard size={20} color="var(--brand-600)" />
            <span style={{ fontSize: 18, fontWeight: 700, color: '#101623' }}>Mock-Checkout</span>
          </div>
          <p style={{ fontSize: 13, color: '#8A93A3', margin: '0 0 4px' }}>
            Lokaler Zahlungs-Simulator (kein echtes Stripe). Wählen Sie das Ergebnis:
          </p>
          <p style={{ fontSize: 11, color: '#B6BDC9', margin: '0 0 24px', fontFamily: 'var(--font-mono, monospace)', wordBreak: 'break-all' }}>
            {sessionId || '— keine Session —'}
          </p>

          <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            <Button
              onClick={() => run('success')}
              disabled={!!busy}
              fullWidth
              leadingIcon={<Check width={16} height={16} />}
              style={{ background: '#17864B', borderColor: '#17864B' }}
            >
              {busy === 'success' ? 'Wird verarbeitet …' : 'Zahlung erfolgreich'}
            </Button>

            <Button
              onClick={() => run('failed')}
              disabled={!!busy}
              fullWidth
              variant="secondary"
              leadingIcon={<AlertTriangle width={16} height={16} />}
            >
              {busy === 'failed' ? 'Wird verarbeitet …' : 'Zahlung fehlgeschlagen'}
            </Button>

            <Button
              onClick={() => run('cancel')}
              disabled={!!busy}
              fullWidth
              variant="ghost"
              leadingIcon={<X width={16} height={16} />}
            >
              {busy === 'cancel' ? 'Wird abgebrochen …' : 'Zahlung abbrechen'}
            </Button>
          </div>
        </Card>
      </div>
      {toast && <Toast message={toast.message} tone={toast.tone} onDismiss={() => setToast(null)} />}
    </Layout>
  );
}

export default MockCheckoutPage;
